import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react'

import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import he from "he";
import { FaFilter } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import "./PickQuestions.css"
import { useNavigate } from 'react-router-dom';
import "./VerifiedQuestions.css"

const VerifiedQuestions = () => {
    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const [loading, setLoading] = useState(false); // for first-time load or filter
    const [loadingMore, setLoadingMore] = useState(false); // for load more only

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedChapter, setSelectedChapter] = useState("");
    const [selectedTopic, setSelectedTopic] = useState("");
    const [selectedLevel, setSelectedLevel] = useState("");
    const [selectedQuestionType, setSelectedQuestionType] = useState("");
    const [selectedExamType, setSelectedExamType] = useState("");
    const [selectedSubject, setSelectedSubject] = useState("");
    const [chapters, setChapters] = useState([]);
    const [topics, setTopics] = useState([]);
    const [levels, setLevels] = useState([]);
    const [questionType, setQuestionType] = useState([]);
    const [examType, setExamType] = useState([]);
    const [subjects, setSubjects] = useState([]);

    const [examTypeFilter, setExamTypeFilter] = useState(""); // For Exam Type
    const [showFilter, setShowFilter] = useState(false);

    const [answersMap, setAnswersMap] = useState({});


    const handleOpenFilter = () => setShowFilter(true);
    const handleCloseFilter = () => setShowFilter(false);

    const loggedInUser = "S3Fwc3A1R2tqeHBPNThNWWp5cy9hdz09";
    const token = "kasejfksjdhfywterjwefbdskgfhsdfjh";

    const observer = useRef();

    const lastQuestionRef = useCallback(
        (node) => {
            if (loadingMore) return;
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMore) {
                    handleLoadMore();
                }
            });

            if (node) observer.current.observe(node);
        },
        [loadingMore, hasMore]
    );

    const fetchQuestions = async (filters = {}, append = false) => {
        if (append) {
            setLoadingMore(true);
        } else {
            setLoading(true);
        }

        try {
            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("programType", "getQuestionDetailsMain");

            fd.append("page", filters.page || page);
            fd.append("limit", filters.limit || itemsPerPage);

            if (filters.subjectId) fd.append("subject", filters.subjectId);
            if (filters.chapterId) fd.append("chapter", filters.chapterId);
            if (filters.topicId) fd.append("topic", filters.topicId);
            if (filters.examType) fd.append("examType", filters.examType);
            if (filters.level) fd.append("level", filters.level);
            if (filters.questionType) fd.append("questionType", filters.questionType);
            if (filters.search) fd.append("search", filters.search);

            const response = await axios.post(
                "https://api.sarvajna.co.in/qp/question/questionCurl",
                fd
            );

            console.log(response)

            let qList = response.data?.questions || [];

            setHasMore(qList.length === (filters.limit || itemsPerPage));
            setQuestions(prev => append ? [...prev, ...qList] : qList);

        } catch (err) {
            console.error("Error fetching questions:", err);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    const handleLoadMore = async () => {
        const nextPage = page + 1;
        setPage(nextPage);

        const filters = {
            subjectId: selectedSubject,
            chapterId: selectedChapter,
            topicId: selectedTopic,
            examType: examTypeFilter,
            level: selectedLevel,
            questionType: selectedQuestionType,
            search: searchQuery,
            search: searchQuery,
            page: nextPage,
            limit: itemsPerPage,
        };
        await fetchQuestions(filters, true);
    };

    const applyFilters = async () => {
        setPage(1);
        const filters = {
            subjectId: selectedSubject,
            chapterId: selectedChapter,
            topicId: selectedTopic,
            examType: examTypeFilter,
            level: selectedLevel,
            search: searchQuery, // ✅ already included
            questionType: selectedQuestionType,
            search: searchQuery,
            page: 1,
            limit: itemsPerPage,
        };
        await fetchQuestions(filters, false);
        setShowFilter(false);
    };

    useEffect(() => {
        fetchQuestions();
    }, []); // Add dependency array here

    async function fetchAnswers(questionId) {
        try {
            const programType = "getOptionsAndAnsForQuestion";
            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("questionId", questionId);
            fd.append("programType", programType);

            const response = await axios.post(
                "https://api.sarvajna.co.in/qp/question/questionCurl",
                fd
            );

            const options = response.data?.options || [];

            setAnswersMap(prev => ({
                ...prev,
                [questionId]: options // ✅ store only options
            }));
        } catch (error) {
            console.error("Error fetching options:", error);
        }
    }

    const renderLatexText = (text) => {
        if (!text) return null; // Check for undefined, null, or empty string

        const decodedText = he.decode(text); // Decode HTML entities
        const latexAndImageRegex =
            /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

        const parts = [];
        let lastIndex = 0;

        decodedText.replace(
            latexAndImageRegex,
            (
                match,
                inlineLatex,
                blockLatex,
                quote,
                imageSrc,
                alignContent,
                index
            ) => {
                if (index > lastIndex) {
                    parts.push(decodedText.slice(lastIndex, index));
                }

                if (imageSrc) {
                    parts.push(
                        <img
                            key={index}
                            src={imageSrc}
                            alt="Image"
                            style={{
                                maxWidth: "100%",
                                display: "inline",
                                verticalAlign: "middle",
                                marginLeft: "4px",
                                marginRight: "4px",
                            }}
                        />
                    );
                } else if (alignContent) {
                    parts.push(
                        <BlockMath
                            key={index}
                            style={{
                                display: "block",
                                textAlign: "center",
                                margin: "10px 0",
                                whiteSpace: "pre-line", // Preserves line breaks
                            }}
                        >
                            {`\\begin{align}${alignContent}\\end{align}`}
                        </BlockMath>
                    );
                } else if (inlineLatex || blockLatex) {
                    parts.push(
                        <InlineMath
                            key={index}
                            style={{
                                display: "inline",
                                verticalAlign: "middle",
                                marginLeft: "4px",
                                marginRight: "4px",
                            }}
                        >
                            {inlineLatex || blockLatex}
                        </InlineMath>
                    );
                }

                lastIndex = index + match.length;
            }
        );

        if (lastIndex < decodedText.length) {
            parts.push(decodedText.slice(lastIndex));
        }

        return (
            <span style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>
        );
    };

    useEffect(() => {
        fetchSubjects();
    }, []);

    async function fetchSubjects() {
        try {
            const role = localStorage.getItem("role");

            const storedSubjectIds =
                JSON.parse(localStorage.getItem("selectedSubjects")) || [];

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("programType", "getSubjectOnChange");
            fd.append("role", role);

            const subjectResponse = await axios.post("qp.sarvajna.co.in/api/controller/onchange/onchangeCurl", fd);

            if (Array.isArray(subjectResponse.data)) {
                // ✅ Filter only the subjects thaft are in selectedSubjects
                const filteredSubjects = subjectResponse.data.filter((subject) =>
                    storedSubjectIds.includes(String(subject.id))
                );
                setSubjects(filteredSubjects);
            } else {
                setSubjects([]);
            }
        } catch (error) {
            console.error("Error fetching subjects:", error);
            setSubjects([]);
        }
    }

    async function fetchChapters(subjectId) {
        if (!subjectId) {
            setChapters([]);
            return;
        }

        try {

            const programType = "getChapterOnChangeMultiple";

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("programType", programType);
            fd.append("subjectId[]", subjectId);

            const chapterResponse = await axios.post("qp.sarvajna.co.in/api/controller/onchange/onchangeCurl", fd);

            if (Array.isArray(chapterResponse.data.data)) {
                // ✅ Get selected chapters from local storage
                const storedChapterIds =
                    JSON.parse(localStorage.getItem("selectedChapters")) || [];

                // ✅ Filter only those chapters whose ID is in storedChapterIds
                const filteredChapters = chapterResponse.data.data.filter((chapter) =>
                    storedChapterIds.includes(String(chapter.id))
                );

                setChapters(filteredChapters);
            } else {
                setChapters([]);
            }
        } catch (error) {
            console.error("Error fetching chapters:", error);
            setChapters([]);
        }
    }

    async function fetchTopics(chapterId) {
        try {

            const programType = "getTopicOnChangeMultiple";

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("programType", programType);
            fd.append("chapterId[]", chapterId);

            // console.log("Fetching topics for Chapter ID:", chapterId);

            const response = await axios.post("qp.sarvajna.co.in/api/controller/onchange/onchangeCurl", fd);

            // console.log("API Response:", response);

            if (Array.isArray(response.data)) {
                // console.log("Topics Fetched:", response.data); // Log topics
                setTopics(response.data);
            } else {
                console.warn("Unexpected API response format", response);
                setTopics([]);
            }
        } catch (error) {
            console.error("Error fetching topics:", error);
            setTopics([]);
        }
    }

    useEffect(() => {
        if (selectedChapter) {
            fetchTopics(selectedChapter);
        } else {
            setSelectedTopic("");
        }
    }, [selectedChapter]);

    async function fetchExamType() {
        try {

            const programType = "getExamTypeDetails";

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("programType", programType);
            // fd.append("examType", examType);

            const response = await axios.post("qp.sarvajna.co.in/api/controller/examType/examTypeCurl", fd);
            // console.log("Response data:", response.data);

            if (Array.isArray(response.data.getExamTypeDetails)) {
                setExamType(response.data.getExamTypeDetails);
            } else {
                // console.error("Data is not an array:", response.data);
                setExamType([]);
            }
        } catch (error) {
            // console.error("Error fetching data:", error);
            setExamType([]);
        }
    }

    useEffect(() => {
        fetchLevel();
        fetchQuestionType();
    }, []);

    async function fetchLevel() {
        try {

            const programType = "getLevelDetails";

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("programType", programType);

            const response = await axios.post("qp.sarvajna.co.in/api/controller/level/levelCurl", fd);
            // console.log("Response data:", response.data);

            if (Array.isArray(response.data.getLevelDetails)) {
                setLevels(response.data.getLevelDetails);
            } else {
                // console.error("Data is not an array:", response.data);
                setLevels([]);
            }
        } catch (error) {
            // console.error("Error fetching data:", error);
            setLevels([]);
        }
    }

    async function fetchQuestionType() {
        try {

            const programType = "getQuestionTypeDetails";

            const fd = new FormData();
            fd.append("loggedInUser", loggedInUser);
            fd.append("token", token);
            fd.append("programType", programType);

            const response = await axios.post("qp.sarvajna.co.in/api/controller/questionType/questionTypeCurl", fd);
            // console.log("Response data:", response.data);

            if (Array.isArray(response.data.getQuestionTypeDetails)) {
                setQuestionType(response.data.getQuestionTypeDetails);
            } else {
                // console.error("Data is not an array:", response.data);
                setQuestionType([]);
            }
        } catch (error) {
            // console.error("Error fetching data:", error);
            setQuestionType([]);
        }
    }


    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (searchQuery.trim() === "") {
                applyFilters(); // Refetch without search
            }
        }, 300); // debounce for better UX

        return () => clearTimeout(delayDebounce);
    }, [searchQuery]);




    return (
        <div
            className="container"
            style={{
                marginBottom: "3rem",
                marginTop: "5rem",
                position: "relative", // you can try removing this if present
                overflow: "visible",  // ensure it's not hiding fixed elements
            }}
        >

            <div
                className="d-flex align-items-center justify-content-between px-3 py-2 shadow-sm"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    zIndex: 1000,
                    height: "3.5rem",
                    borderBottom: "1px solid #ddd",
                }}
            >
                <button
                    className="btn btn-link p-0 m-0"
                    onClick={() => navigate(-1)}
                    style={{ fontSize: "1.2rem", color: "#000" }}
                >
                    <i className="bi bi-arrow-left"></i>
                </button>
                <h6 className="m-0 text-center flex-grow-1">📋 Verified Questions</h6>
                <div style={{ width: "2rem" }} /> {/* Placeholder to balance back button */}
            </div>

            <div className="input-group my-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Question ID"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            applyFilters();
                        }
                    }}
                />
                <button className="btn btn-primary" onClick={applyFilters}>
                    Search
                </button>
            </div>

            {loading && (
                <p className="text-center text-primary">Loading...</p>
            )}




            <div className="list-group">
                {questions.map((q, index) => {
                    const isLast = index === questions.length - 1;
                    return (
                        <div
                            ref={isLast ? lastQuestionRef : null}
                            key={q.id}
                            className={`list-group-item position-relative shadow-sm mb-3 rounded border ${q.isPicked ? "border-success" : ""
                                }`}
                            style={{

                                backgroundColor: q.isPicked ? "#e7f9f1" : "#fff",
                                paddingBottom: "2rem", // Extra space to avoid overlap
                            }}
                            onClick={() => fetchAnswers(q.id)} // ✅ call on click
                        >
                            <div className="d-flex align-items-start mb-2">
                                <strong className="me-2">{index + 1}.</strong>
                                <strong className="flex-grow-1">{renderLatexText(q.question)}</strong>
                            </div>

                            {answersMap[q.id] && (
                                <div className="mt-3 options-grid">
                                    {answersMap[q.id].map((opt, idx) => {
                                        // Check length of plain text (no HTML/LaTeX tags)
                                        const plainText = he.decode(opt).replace(/<[^>]+>/g, "").trim();
                                        const isLong = plainText.length > 20; // threshold for long option

                                        return (
                                            <div
                                                key={idx}
                                                className={`option-item ${isLong ? "full-width" : ""}`}
                                            >
                                                <span className="option-number">{idx + 1}.</span>{" "}
                                                <span className="option-text">{renderLatexText(opt)}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            <div
                                style={{
                                    padding: "2px 10px 2px 10px",
                                    position: "absolute",
                                    bottom: "8px",
                                    right: "12px",
                                    borderRadius: "25px",
                                    fontSize: "0.75rem",
                                    color: "#fff",
                                    backgroundColor: "#FFB38A"
                                }}
                            >
                                ID: {q.id}
                            </div>


                        </div>
                    );
                })}

                {loadingMore && (
                    <div className="text-center mt-3">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading more...</span>
                        </div>
                    </div>
                )}
            </div>



            {/* Floating Menu Button */}
            <button
                onClick={handleOpenFilter}
                className="btn  rounded-circle shadow"
                style={{
                    position: "fixed",
                    bottom: "100px",
                    right: "20px",
                    width: "45px",
                    height: "45px",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "26px",
                    backgroundColor: "#FFFFFF"
                }}
            >
                <FaFilter style={{ fontSize: "30px" }} />
            </button>
            {/* Filter Modal */}
            <Modal
                show={showFilter}
                onHide={handleCloseFilter}
                animation={true}
                centered
                size="xs"
                dialogClassName="modern-filter-modal"
            >
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="fw-bold fs-4 ">🔍 Filter Questions</Modal.Title>
                </Modal.Header>

                <Modal.Body className="py-3 px-4">
                    <div className="row g-3">
                        {/* Subject */}
                        <div className="col-md-6">
                            <label className="form-label">Subject</label>
                            <select
                                className="form-select"
                                value={selectedSubject}
                                onChange={async (e) => {
                                    const subjectId = e.target.value;
                                    setSelectedSubject(subjectId);
                                    setSelectedChapter("");
                                    setSelectedTopic("");
                                    setChapters([]);
                                    setTopics([]);
                                    await fetchChapters(subjectId);
                                }}
                            >
                                <option value="">Select Subject</option>
                                {subjects.map((subject) => (
                                    <option key={subject.id} value={subject.id}>
                                        {subject.subjectName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Chapter */}
                        <div className="col-md-6">
                            <label className="form-label">Chapter</label>
                            <select
                                className="form-select"
                                value={selectedChapter}
                                onChange={(e) => setSelectedChapter(e.target.value)}
                            >
                                <option value="">Select Chapter</option>
                                {chapters.map((chapter) => (
                                    <option key={chapter.id} value={chapter.id}>
                                        {chapter.chapterName} ({chapter.chapterCount})
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Topic */}
                        <div className="col-md-6">
                            <label className="form-label">Topic</label>
                            <select
                                className="form-select"
                                value={selectedTopic}
                                onChange={(e) => setSelectedTopic(e.target.value)}
                            >
                                <option value="">Select Topic</option>
                                {topics.map((topic) => (
                                    <option key={topic.id} value={topic.id}>
                                        {topic.topicName} ({topic.topicCount})
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Exam Type */}
                        <div className="col-md-6">
                            <label className="form-label">Exam Type</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Filter by Exam Type"
                                value={examTypeFilter}
                                onChange={(e) => setExamTypeFilter(e.target.value.trim() || null)}
                            />
                        </div>

                        {/* Level */}
                        <div className="col-md-6">
                            <label className="form-label">Level</label>
                            <select
                                className="form-select"
                                value={selectedLevel}
                                onChange={(e) => setSelectedLevel(e.target.value)}
                            >
                                <option value="">Select Level</option>
                                {levels.map((level) => (
                                    <option key={level.id} value={level.id}>
                                        {level.levelName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Question Type */}
                        <div className="col-md-6">
                            <label className="form-label">Question Type</label>
                            <select
                                className="form-select"
                                value={selectedQuestionType}
                                onChange={(e) => setSelectedQuestionType(e.target.value)}
                            >
                                <option value="">Select Question Type</option>
                                {questionType.map((qt) => (
                                    <option key={qt.id} value={qt.id}>
                                        {qt.questionType}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex justify-content-between gap-3 mt-4">
                        <button className="btn btn-outline-secondary w-100">
                            Reset
                        </button>

                        <button className="btn btn-secondary w-100" style={{ color: "white" }} onClick={applyFilters}>
                            Apply Filters
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default VerifiedQuestions